import axios from 'axios'
import store from '../helpers/store'
import * as config from 'config'
import { userActions } from '../actions'
import { toastActions } from './../actions/toast.actions'
import { ClientService } from './client.service'
import { AuthenticationService } from './authentication.service'
import { Creators as SiteCreators } from '../ducks/site/site'

const requestIds = []

function getBaseConfig() {
	const user = store.getState().user
	if (!user) return null
	return {
		headers: {
			Authorization: `Bearer ${user.accessToken}`,
			Pragma: 'no-cache',
		},
	}
}

const loaderIgnoredPaths = [
	'/',
	'/regulamento',
	'/perguntas-frequentes',
	'/politica-de-privacidade',
]

const toastIgnorePaths = ['/cliente/compra-de-passagem', '/compra-de-passagem']

function handleError(error) {
	const loaderEnabled = !loaderIgnoredPaths.includes(location.pathname)
	loaderEnabled && store.dispatch(SiteCreators.showLoading())
	const user = store.getState().user
	return new Promise((resolve, reject) => {
		if (error.response && error.response.status === 401 && user) {
			AuthenticationService.refreshToken(user.id, user.refreshToken)
				.then(({ success, data }) => {
					if (success) {
						store.dispatch(userActions.login(data))
						ClientService.getSubscription().then(
							({ success, ...response }) => {
								if (success && response.data) {
									data.plan = response.data
									store.dispatch(userActions.login(data))
								}
							}
						)

						error.config.headers.Authorization = 'Bearer '.concat(
							data.accessToken
						)
						loaderEnabled && store.dispatch(SiteCreators.hideLoading())
						resolve(
							axios(error.config).catch(() => {
								store.dispatch(userActions.logout())
								loaderEnabled &&
									store.dispatch(SiteCreators.hideLoading())
								reject(error)
							})
						)
					} else {
						store.dispatch(userActions.logout())
						loaderEnabled && store.dispatch(SiteCreators.hideLoading())
						reject(error)
					}
				})
				.catch(() => {
					store.dispatch(userActions.logout())
					loaderEnabled && store.dispatch(SiteCreators.hideLoading())
					reject(error)
				})
		} else {
			loaderEnabled && store.dispatch(SiteCreators.hideLoading())
			reject(error)
		}
	})
}

const handleSuccess = (data) => {
	const { errors } = data.data
	if (errors && errors.length && errors[0] != 'O Refresh token é inválido') {
		if (!toastIgnorePaths.includes(location.pathname))
			store.dispatch(toastActions.danger({ message: errors[0] }))
	}

	return data
}

export class AxiosService {
	static baseURL = config.apiUrl

	/**
	 * Initializes the axios configuration and add interceptors
	 */
	static init() {
		axios.interceptors.response.use((res) => res, handleError)
	}

	/**
	 * The http get
	 * @param {*} url The server url
	 * @param {*} config The configuration of GET
	 * @param {*} options The options of GET
	 */
	static get(url, config, options = {}) {
		if (options.requestId !== undefined) {
			if (requestIds.includes(options.requestId)) {
				return Promise.resolve({})
			} else {
				requestIds.push(options.requestId)
			}
		}
		return axios
			.get(this.baseURL + url, Object.assign({}, getBaseConfig(), config))
			.then((response) => {
				if (options.requestId !== undefined) {
					const idIndex = requestIds.indexOf(options.requestId)
					requestIds.splice(idIndex, 1)
				}

				return response
			})
			.catch((error) => {
				requestIds.splice(requestIds.indexOf(options.requestId), 1)

				throw new Error(error)
			})
	}

	/**
	 * The http post
	 * @param {string} url The server url
	 * @param {object} params The request data
	 * @param {object} config The configuration of POST
	 */
	static post(url, params, config) {
		return axios
			.post(
				this.baseURL + url,
				params,
				Object.assign({}, getBaseConfig(), config)
			)
			.then(handleSuccess)
			.catch((error) => {
				requestIds.splice(requestIds.indexOf(options.requestId), 1)

				throw new Error(error)
			})
	}

	/**
	 * The http put
	 * @param {string} url The server url
	 * @param {object} params The request data
	 * @param {object} config The configuration of POST
	 */
	static put(url, params, config) {
		return axios
			.put(
				this.baseURL + url,
				params,
				Object.assign({}, getBaseConfig(), config)
			)
			.then(handleSuccess)
			.catch((error) => {
				requestIds.splice(requestIds.indexOf(options.requestId), 1)

				throw new Error(error)
			})
	}
}
